"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectUsersToRemoveSharedAccess = exports.removeSharedAccessNode = exports.ShareScopeOptions = exports.ShareOperationOptions = exports.shareNode = exports.MAX_SHARE_EMAILS = exports.ShareScopeOption = exports.ShareOperationOption = void 0;
const teamsDevPortalClient_1 = require("../client/teamsDevPortalClient");
const constants_1 = require("../common/constants");
const globalVars_1 = require("../common/globalVars");
const localizeUtils_1 = require("../common/localizeUtils");
const utils_1 = require("../component/driver/share/utils");
const collaborator_1 = require("../core/collaborator");
const constants_2 = require("./constants");
const other_1 = require("./other");
var ShareOperationOption;
(function (ShareOperationOption) {
    ShareOperationOption["ShareWithUsers"] = "share";
    ShareOperationOption["RemoveShareAccessFromUsers"] = "unshare";
})(ShareOperationOption = exports.ShareOperationOption || (exports.ShareOperationOption = {}));
var ShareScopeOption;
(function (ShareScopeOption) {
    ShareScopeOption["ShareAppWithTenantUsers"] = "tenant";
    ShareScopeOption["ShareAppWithSpecificUsers"] = "users";
})(ShareScopeOption = exports.ShareScopeOption || (exports.ShareScopeOption = {}));
exports.MAX_SHARE_EMAILS = 20;
function shareNode() {
    return {
        data: shareOperationOptions(),
        children: [
            shareScopeOptions(),
            {
                condition: (inputs) => {
                    return (inputs[constants_2.QuestionNames.ShareOperation] === ShareOperationOption.RemoveShareAccessFromUsers);
                },
                data: (0, other_1.inputUserEmailQuestion)((0, localizeUtils_1.getLocalizedString)("core.shareOptionQuestion.unshare.emails.title"), "Email address of specific users or groups separated by comma.", false),
            },
        ],
    };
}
exports.shareNode = shareNode;
function shareOperationOptions() {
    return {
        name: constants_2.QuestionNames.ShareOperation,
        title: (0, localizeUtils_1.getLocalizedString)("core.shareOptionQuestion.title"),
        type: "singleSelect",
        placeholder: (0, localizeUtils_1.getLocalizedString)("core.shareOptionQuestion.placeholder"),
        staticOptions: [
            ShareOperationOptions.shareWithUsers(),
            ShareOperationOptions.removeShareAccessFromUsers(),
        ],
    };
}
function shareScopeOptions() {
    return {
        condition: { equals: ShareOperationOptions.shareWithUsers().id },
        data: {
            type: "singleSelect",
            name: constants_2.QuestionNames.ShareScope,
            title: (0, localizeUtils_1.getLocalizedString)("core.shareScopeQuestion.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.shareScopeQuestion.placeholder"),
            staticOptions: [ShareScopeOptions.shareWithTenant(), ShareScopeOptions.shareWithUsers()],
            default: ShareScopeOptions.shareWithUsers().id,
        },
        children: [
            {
                condition: (inputs) => {
                    return inputs[constants_2.QuestionNames.ShareScope] === ShareScopeOption.ShareAppWithSpecificUsers;
                },
                data: (0, other_1.inputUserEmailQuestion)((0, localizeUtils_1.getLocalizedString)("core.shareScopeQuestion.emails.title"), "Email address of specific users or groups separated by comma.", false),
            },
        ],
    };
}
class ShareOperationOptions {
    static shareWithUsers() {
        return {
            id: ShareOperationOption.ShareWithUsers,
            label: (0, localizeUtils_1.getLocalizedString)("core.shareOperationQuestion.option.shareWithUsers"),
        };
    }
    static removeShareAccessFromUsers() {
        return {
            id: ShareOperationOption.RemoveShareAccessFromUsers,
            label: (0, localizeUtils_1.getLocalizedString)("core.shareOperationQuestion.option.removeShareAccessFromUsers"),
        };
    }
}
exports.ShareOperationOptions = ShareOperationOptions;
class ShareScopeOptions {
    static shareWithTenant() {
        return {
            id: ShareScopeOption.ShareAppWithTenantUsers,
            label: (0, localizeUtils_1.getLocalizedString)("core.shareScopeQuestion.option.shareWithTenant"),
        };
    }
    static shareWithUsers() {
        return {
            id: ShareScopeOption.ShareAppWithSpecificUsers,
            label: (0, localizeUtils_1.getLocalizedString)("core.shareScopeQuestion.option.shareWithUsers"),
        };
    }
}
exports.ShareScopeOptions = ShareScopeOptions;
function removeSharedAccessNode() {
    return {
        data: {
            type: "group",
        },
        children: [
            {
                data: selectUsersToRemoveSharedAccess(),
            },
        ],
    };
}
exports.removeSharedAccessNode = removeSharedAccessNode;
function selectUsersToRemoveSharedAccess() {
    return {
        name: constants_2.QuestionNames.RemoveUsers,
        title: (0, localizeUtils_1.getLocalizedString)("core.selectUsersToRemoveShareAccess.title"),
        type: "multiSelect",
        cliDescription: (0, localizeUtils_1.getLocalizedString)("core.selectUsersToRemoveShareAccess.title"),
        staticOptions: [],
        dynamicOptions: async (inputs) => {
            if (!inputs.projectPath) {
                throw new Error("Project path is not defined");
            }
            const tokenRes = await globalVars_1.TOOLS.tokenProvider.m365TokenProvider.getAccessToken({
                scopes: constants_1.AppStudioScopes,
            });
            if (tokenRes.isErr()) {
                throw tokenRes.error;
            }
            const token = tokenRes.value;
            const configRes = await (0, utils_1.parseShareAppActionYamlConfig)(inputs.projectPath);
            if (configRes.isErr()) {
                throw configRes.error;
            }
            const teamsAppId = configRes.value.teamsappId;
            const app = await teamsDevPortalClient_1.teamsDevPortalClient.getApp(token, teamsAppId);
            if (!app.userList || app.userList.length === 0) {
                throw new Error("No owner found in the app");
            }
            const currentUserInfoRes = await collaborator_1.CollaborationUtil.getCurrentUserInfo(globalVars_1.TOOLS.tokenProvider.m365TokenProvider);
            if (currentUserInfoRes.isErr()) {
                throw currentUserInfoRes.error;
            }
            const operatorId = currentUserInfoRes.value.aadId;
            const options = [];
            for (const user of app.userList) {
                if (user.aadId === operatorId) {
                    continue;
                }
                options.push({
                    id: user.userPrincipalName,
                    label: user.displayName,
                    description: user.userPrincipalName,
                });
            }
            return options;
        },
        skipValidation: true,
    };
}
exports.selectUsersToRemoveSharedAccess = selectUsersToRemoveSharedAccess;
//# sourceMappingURL=share.js.map